export default class DevelopmentDatePickerController {
	/* @ngInject */
	constructor() {
		this.settings = {
			allowInfinity:     false,
			allowInput:        false,
			allowSetNow:       true,
			altFormat:         'd/m/Y H:i:s',
			enableTime:        false,
			label:             undefined,
			placeholder:       'My date',
			static:            true,
			weekNumbers:       false,
		};
		this.readOnly = false;
		this.required = false;
	}
}
